import { render } from "./VueMarkdown.vue?vue&type=template&id=5d92bc30"
import script from "./VueMarkdown.vue?vue&type=script&lang=js"
export * from "./VueMarkdown.vue?vue&type=script&lang=js"

import exportComponent from "/apps/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__